import { DEFAULT_SITE_CONFIG } from '../../lib/siteConfig';

export default function PhoneMockup({ big = false, mini = false, mapImg, propertyImg }) {
  const map = mapImg || DEFAULT_SITE_CONFIG.hero.phone_map;
  const property = propertyImg || DEFAULT_SITE_CONFIG.hero.phone_property;

  if (mini) {
    return (
      <div className="relative flex items-start" data-testid="phone-mockup-mini">
        <img
          src={map}
          alt="App CNIB Connect: mapa colaborativo de propiedades"
          className="relative z-10 w-[110px] animate-float-slow drop-shadow-[0_18px_28px_rgba(0,0,0,0.55)] xs:w-[125px] sm:w-[150px]"
        />
        <img
          src={property}
          alt="App CNIB Connect: ficha de propiedad con botón de contacto"
          className="absolute -right-10 top-7 z-0 w-[85px] rotate-[6deg] animate-float-slow drop-shadow-[0_14px_22px_rgba(0,0,0,0.5)] xs:-right-12 xs:w-[95px] sm:-right-14 sm:top-8 sm:w-[115px]"
          style={{ animationDelay: '1.2s' }}
        />
      </div>
    );
  }

  return (
    <div className="relative flex items-start" data-testid="phone-mockup">
      <img
        src={map}
        alt="App CNIB Connect: mapa colaborativo de propiedades"
        className={`relative z-10 animate-float-slow drop-shadow-[0_40px_60px_rgba(0,0,0,0.55)] ${
          big ? 'w-[320px] sm:w-[400px] lg:w-[440px] xl:w-[480px]' : 'w-[290px] sm:w-[330px] lg:w-[360px]'
        }`}
      />
      <img
        src={property}
        alt="App CNIB Connect: ficha de propiedad con botón de contacto"
        className={`absolute z-0 hidden rotate-[5deg] animate-float-slow drop-shadow-[0_30px_50px_rgba(0,0,0,0.5)] sm:block ${
          big
            ? '-right-24 top-16 w-[280px] lg:-right-36 lg:w-[320px] xl:w-[340px]'
            : '-right-20 top-14 w-[225px] lg:-right-28 lg:w-[250px]'
        }`}
        style={{ animationDelay: '1.2s' }}
      />
    </div>
  );
}
